import {Component, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'ld-input-password-visibility-toggle',
  templateUrl: 'input-password-visibility-toggle.component.html',
  styleUrls: ['input-password-visibility-toggle.component.css']
})
export class InputPasswordVisibilityToggleComponent {

  @Output()
  visibilityChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  isVisible: boolean;

  constructor() { }

  onToggle() {
    this.isVisible = !this.isVisible;
    this.visibilityChange.emit(this.isVisible);
  }

  onKeypress(event) {
    switch (event.key) {
      case ('Space'):
      case ('Spacebar'):
      case (' '):
      case ('Enter'):
        this.onToggle();
      default:
        event.stopPropagation();
        return false;
    }
  }
}
